import mirrorCreator from 'mirror-creator';

const actionTypes = mirrorCreator(['ADD_MESSAGE', 'REMOVE_MESSAGE']);

export default actionTypes;
